module.exports = __webpack_public_path__ + "img/attachment.a79bdca0.svg";